import { render, staticRenderFns } from "./InboundTableTypeBlock.vue?vue&type=template&id=32ce31ec&scoped=true"
import script from "./InboundTableTypeBlock.vue?vue&type=script&lang=js"
export * from "./InboundTableTypeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce31ec",
  null
  
)

export default component.exports